// @ts-ignore - qrcode types not available
import QRCode from 'qrcode';

export const generateQRCodeDataURL = async (text: string, options: QRCodeOptions = {}): Promise<string> => {
  const { width = 247, margin = 1, darkColor = '#000000', lightColor = '#FFFFFF' } = options;

  if (!text) {
    throw new Error('No text provided for QR code generation');
  }

  try {
    const qrDataURL = await QRCode.toDataURL(text, {
      width,
      margin,
      color: {
        dark: darkColor,
        light: lightColor,
      },
    });

    return qrDataURL;
  } catch (error) {
    console.error('QR Code generation failed:', error);
    throw new Error(typeof error === 'string' ? error : 'Failed to generate QR code');
  }
};

export interface QRCodeOptions {
  width?: number;
  margin?: number;
  darkColor?: string;
  lightColor?: string;
}
